import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import LandlordsPage from "@/pages/LandlordsPage";
import OperatorsPage from "@/pages/OperatorsPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import SitesPage from "@/pages/SitesPage";
import UsesPage from "@/pages/UsesPage";
import AdminPage from "@/pages/AdminPage";
import GalleryPage from "@/pages/GalleryPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/landlords" element={<LandlordsPage />} />
          <Route path="/operators" element={<OperatorsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/sites" element={<SitesPage />} />
          <Route path="/uses" element={<UsesPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
